// extracted by mini-css-extract-plugin
export default {"container":"SearchTabs_container__Oiiac","tab":"SearchTabs_tab__9-JvH","current":"SearchTabs_current__YLXV3"};